// extracted by mini-css-extract-plugin
module.exports = {"list":"list-2TAUnWE1 clearfix","item":"item-2pdAZ0v2 clearfix","pic":"pic-30gq0kfc","content":"content-1z3Y_oh7","title":"title-31m9JMuT"};